import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

function TabButtonFilled({ label, onClick, ultraWide, wide }) {
  return (
    <Fragment key={`tab-button-filled-${label}`}>
      {ultraWide && (
        <svg
          fill="none"
          height="37"
          viewBox="0 0 194 37"
          width="194"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_439_430)">
            <mask fill="white" id="path-1-inside-1_439_430">
              <path d="M143 0C143.105 0.00114396 162.573 0.238765 166.521 18.5947C170.481 37 194.269 37 194.269 37H152V37.0098H42V37H0C0 37 23.7874 37 27.7471 18.5947C31.696 0.238765 51.1639 0.00114396 51.2686 0V0.0390625C51.5102 0.0215919 51.7539 0.00976563 52 0.00976562H142C142.338 0.00976562 142.671 0.0269127 143 0.0595703V0Z" />
            </mask>
            <path
              d="M143 0C143.105 0.00114396 162.573 0.238765 166.521 18.5947C170.481 37 194.269 37 194.269 37H152V37.0098H42V37H0C0 37 23.7874 37 27.7471 18.5947C31.696 0.238765 51.1639 0.00114396 51.2686 0V0.0390625C51.5102 0.0215919 51.7539 0.00976563 52 0.00976562H142C142.338 0.00976562 142.671 0.0269127 143 0.0595703V0Z"
              fill="currentColor"
            />
            <path
              d="M143 0L143.022 -1.99988L141 -2.02199V0H143ZM166.521 18.5947L164.566 19.0154L164.566 19.0154L166.521 18.5947ZM152 37V35H150V37H152ZM152 37.0098V39.0098H154V37.0098H152ZM42 37.0098H40V39.0098H42V37.0098ZM42 37H44V35H42V37ZM27.7471 18.5947L29.7023 19.0154L29.7023 19.0154L27.7471 18.5947ZM51.2686 0H53.2686V-2.02199L51.2467 -1.99988L51.2686 0ZM51.2686 0.0390625H49.2686V2.18891L51.4128 2.03385L51.2686 0.0390625ZM52 0.00976562L52 -1.99023L52 -1.99023L52 0.00976562ZM143 0.0595703L142.802 2.04978L145 2.26798V0.0595703H143ZM143 0L142.978 1.99988C142.917 1.99921 147.5 2.04853 152.517 4.24624C157.464 6.41347 162.76 10.6209 164.566 19.0154L166.521 18.5947L168.477 18.1741C166.334 8.21261 159.922 3.12323 154.122 0.582375C148.391 -1.928 143.188 -1.99806 143.022 -1.99988L143 0ZM166.521 18.5947L164.566 19.0154C166.751 29.1719 174.435 34.1641 181.207 36.5828C184.603 37.7958 187.851 38.397 190.241 38.6969C191.439 38.8472 192.431 38.9229 193.13 38.9611C193.479 38.9802 193.756 38.9899 193.949 38.9948C194.046 38.9973 194.122 38.9986 194.175 38.9993C194.202 38.9996 194.223 38.9998 194.239 38.9999C194.247 38.9999 194.253 39 194.258 39C194.261 39 194.263 39 194.264 39C194.265 39 194.266 39 194.267 39C194.268 39 194.269 39 194.269 37C194.269 35 194.269 35 194.27 35C194.27 35 194.27 35 194.271 35C194.271 35 194.271 35 194.27 35C194.269 35 194.267 35 194.264 35C194.256 34.9999 194.243 34.9998 194.225 34.9996C194.188 34.9991 194.13 34.9982 194.052 34.9962C193.895 34.9921 193.656 34.9839 193.348 34.967C192.73 34.9333 191.832 34.8652 190.739 34.728C188.545 34.4527 185.598 33.9036 182.553 32.8159C176.441 30.6333 170.251 26.4228 168.477 18.1741L166.521 18.5947ZM194.269 37V35H152V37V39H194.269V37ZM152 37H150V37.0098H152H154V37H152ZM152 37.0098V35.0098H42V37.0098V39.0098H152V37.0098ZM42 37.0098H44V37H42H40V37.0098H42ZM42 37V35H0V37V39H42V37ZM0 37C6.44755e-07 39 0.000848348 39 0.00178647 39C0.00222055 39 0.00325181 39 0.00412023 39C0.00585828 39 0.00796037 39 0.0104239 39C0.0153508 39 0.0217238 38.9999 0.0295218 38.9999C0.0451174 38.9998 0.066416 38.9996 0.0932498 38.9993C0.146913 38.9986 0.222742 38.9973 0.319392 38.9948C0.512652 38.9899 0.789418 38.9802 1.13892 38.9611C1.83748 38.9229 2.82926 38.8472 4.02765 38.6969C6.41732 38.397 9.66509 37.7958 13.0613 36.5828C19.8338 34.1641 27.5173 29.1719 29.7023 19.0154L27.7471 18.5947L25.7918 18.1741C24.0172 26.4228 17.8271 30.6333 11.716 32.8159C8.6704 33.9036 5.72385 34.4527 3.52965 34.728C2.4361 34.8652 1.53856 34.9333 0.920774 34.967C0.612107 34.9839 0.373949 34.9921 0.216828 34.9962C0.138288 34.9982 0.0800612 34.9991 0.0434673 34.9996C0.0251724 34.9998 0.0122917 34.9999 0.0049902 35C0.00133967 35 -0.000915364 35 -0.00175428 35C-0.0021737 35 -0.00223901 35 -0.00194763 35C-0.00180254 35 -0.00131443 35 -0.00124267 35C-0.000666865 35 -6.44755e-07 35 0 37ZM27.7471 18.5947L29.7023 19.0154C31.5083 10.6209 36.8047 6.41347 41.7519 4.24624C46.7687 2.04853 51.3519 1.99921 51.2904 1.99988L51.2686 0L51.2467 -1.99988C51.0806 -1.99806 45.8775 -1.928 40.1469 0.582375C34.3468 3.12323 27.9348 8.21261 25.7918 18.1741L27.7471 18.5947ZM51.2686 0H49.2686V0.0390625H51.2686H53.2686V0H51.2686ZM51.2686 0.0390625L51.4128 2.03385C51.6239 2.01859 51.8169 2.00977 52 2.00977L52 0.00976562L52 -1.99023C51.691 -1.99023 51.3965 -1.97541 51.1243 -1.95573L51.2686 0.0390625ZM52 0.00976562V2.00977H142V0.00976562V-1.99023H52V0.00976562ZM142 0.00976562V2.00977C142.27 2.00977 142.537 2.02347 142.802 2.04978L143 0.0595703L143.198 -1.93064C142.805 -1.96964 142.405 -1.99023 142 -1.99023V0.00976562ZM143 0.0595703H145V0H143H141V0.0595703H143Z"
              fill="currentColor"
              mask="url(#path-1-inside-1_439_430)"
            />
            <text
              dominantBaseline="middle"
              onClick={onClick}
              textAnchor="middle"
              x="50%"
              y="53%"
            >
              {label}
            </text>
          </g>
          <defs>
            <clipPath id="clip0_439_430">
              <rect fill="white" height="37" width="194" />
            </clipPath>
          </defs>
        </svg>
      )}
      {wide && (
        <svg
          height="35px"
          version="1.1"
          viewBox="0 0 226 35"
          width="226px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <path
              d="M38.2689118,0.999999998 L187.991089,1.00983112 C194.248778,1.06559322 199.273507,2.55186945 203.040681,5.52832868 C206.797216,8.49638106 209.28119,12.9340034 210.544201,18.8048821 C211.925272,25.2245376 215.050983,30.0250112 219.885643,33.2319731 C221.570093,34.3493146 223.46656,35.2729235 225.576053,36 L197.999942,36 L27.0002468,36.0098708 L0.683123036,36.0033766 C2.79654359,35.2757837 4.69627604,34.3510449 6.38333447,33.2319731 C11.2179943,30.0250112 14.3437057,25.2245376 15.7247764,18.8048821 C16.8957686,13.3617381 19.1155038,9.15093664 22.4270671,6.1997592 C25.7336688,3.25300347 30.1159603,1.57571211 35.5529789,1.12339463 C36.0719642,1.04554247 36.5318111,1.00987082 37.0009516,1.00987036 L37.7222669,1.00918393 C37.9066313,1.00483334 38.0922943,1.00175585 38.2689118,0.999999998 Z"
              fill="currentColor"
              id="tab-button-filled-wide"
              stroke="currentColor"
              strokeWidth="2"
            />
            <text
              dominantBaseline="middle"
              onClick={onClick}
              textAnchor="middle"
              x="50%"
              y="53%"
            >
              {label}
            </text>
          </g>
        </svg>
      )}
      {!wide && !ultraWide && (
        <svg
          aria-label={label}
          height="41"
          role="tab"
          viewBox="0 0 159 41"
          width="159"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <path
              d="M107 2c.187.002.374.005.559.01H108c.404 0 .803.024 1.195.07 11.73.778 18.839 6.949 21.327 18.515C133.162 32.865 142.41 39 158.269 39H118l-75 .01V39H1c15.858 0 25.107-6.135 27.747-18.405C31.387 8.325 39.227 2.126 52.27 2l-.001.036c.242-.017.486-.026.732-.026l54-.001z"
              fill="currentColor"
              onClick={onClick}
            />
          </g>
          <text
            dominantBaseline="middle"
            onClick={onClick}
            textAnchor="middle"
            x="50%"
            y="53%"
          >
            {label}
          </text>
        </svg>
      )}
    </Fragment>
  )
}

TabButtonFilled.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  ultraWide: PropTypes.bool,
  wide: PropTypes.bool,
}

export default TabButtonFilled
